import React, { useState, useMemo, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import * as Api from "../../api";
import {
  // updateRestaurantCategoryList,
  updateRestaurantMenuList,
} from "../../redux/actions/userDataActions";
// components
import Container from "../../components/Container";
import Loader from "../../components/Loader";
import AlertMsg from "../../components/AlertMsg";
import ModifierMenuItems from "./ModifierMenuItems";
import AddModifiers from "./AddModifiers";
import RestaurantHeader from "../../components/RestaurantHeader";
import AppDialog from "../../components/AppDialog";
// styles
import styles from "./Modifiers.module.css";
// icons
import { ReactComponent as DeleteIcon } from "../../assets/images/delete3.svg";

const Modifiers = (props) => {
  const navigate = useNavigate();
  const restaurantId = useParams().rest_id;
  const [loading, setLoading] = useState(true);
  const [modifierList, setModifierList] = useState([]);
  const [selectedModifier, setSelectedModifier] = useState(null);
  const [selectedMenuItems, setSelectedMenuItems] = useState([]);
  const [appDialogState, setAppDialogState] = useState({ open: false });
  const [menuCategoryList, setMenuCategoryList] = useState([]);
  const [msgAlert, setMsgAlert] = useState({
    open: false,
    message: "",
    msgType: "error",
  });
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    console.log(selectedModifier?.menuItemIds, "selectedModifier?.menuItemIds");
    setSelectedMenuItems(selectedModifier?.menuItemIds ?? []);
  }, [selectedModifier?.menuItemIds]);

  useEffect(() => {
    getCategoryList();
  }, []);

  useEffect(() => {
    if (props.restaurantMenuList.length && categoryList.length) {
      const list = categoryList.map((item) => {
        return {
          ...item,
          menuList: props.restaurantMenuList?.filter(
            (menu) => menu?._idCategory === item?._id
          ),
        };
      });
      setMenuCategoryList(list);
    }
  }, [props.restaurantMenuList, categoryList]);

  const getCategoryList = async () => {
    const filter = "all";
    const response = await Api.getCategoryList(restaurantId, filter);
    if (response.success) {
      const data = response.data.rows.sort((a, b) => a?.order - b?.order);
      // Update local state instead of redux
      setCategoryList(data);
      getMenuList();
    } else {
      setMsgAlert({ open: true, message: response.msg, msgType: "error" });
    }
  };

  const getMenuList = async () => {
    const paginationParams =
      "?pageSize=300000&pageNum=1&orderBy=order&orderByDir=asc";
    const response = await Api.getMenuListModifiers(
      restaurantId,
      paginationParams
    );
    if (response.success) {
      const menuItems = response.data.rows;
      props.updateRestaurantMenuList(menuItems);
      getMenuModifiers(menuItems);
    } else {
      setMsgAlert({
        open: true,
        message: response.msg,
        msgType: "error",
      });
      setLoading(false);
    }
  };

  const getMenuModifiers = async (menuList) => {
    setLoading(true);
    const paginationParams = `?pageSize=300000&pageNum=1`;
    const response = await Api.getMenuModifier(paginationParams, restaurantId);
    if (response.success) {
      const menuItemsWithModifiers = menuList.filter(
        (x) => x?._idModifiers?.length > 0
      );
      const modifiersWithMenus = response?.data?.rows?.map((mod) => {
        const linkedMenuIds = menuItemsWithModifiers
          .filter((item) => item?._idModifiers?.includes(mod?._id))
          .map((x) => x._id);
        return {
          _idModifier: mod?._id,
          menuItemIds: linkedMenuIds,
          ...(mod?.modifiers?.[0] ?? null),
        };
      });
      setModifierList(modifiersWithMenus);
    } else {
      setMsgAlert({
        open: true,
        message: response.msg,
        msgType: "error",
      });
    }
    setLoading(false);
  };

  const onModifierClick = (modifier) => {
    if (modifier?._id !== selectedModifier?._id) {
      const { restaurantMenuList } = props;
      const modifierItems = [];

      modifier.items.forEach((itm) => {
        if (typeof itm === "string") {
          const index = restaurantMenuList.findIndex((z) => z._id === itm);
          if (index >= 0) {
            modifierItems.push(restaurantMenuList[index]);
          }
        } else {
          modifierItems.push(itm);
        }
      });

      const data = { ...modifier, items: modifierItems };
      setSelectedModifier(structuredClone(data));
    }
  };

  const onSelectModifierMenu = (menuItem) => {
    const menuId = menuItem?._id;
    console.log(menuId, "menuId");
    setSelectedMenuItems((prev) => {
      if (prev.includes(menuId)) {
        console.log("first");
        return prev.filter((x) => x !== menuId);
      } else {
        return [...prev, menuId];
      }
    });
  };

  const onSaveModifierMenu = () => {
    if (selectedModifier?._id !== "add") {
      const updatedModifier = {
        ...selectedModifier,
        menuItemIds: selectedMenuItems,
      };

      const linkData = {
        id: [selectedModifier?._idModifier],
        menuItemIds: selectedMenuItems,
      };
      linkMenuModifiers(linkData, "edit", updatedModifier);
    } else {
      const modifiersCopy = [...modifierList];
      const modifierIndex = modifiersCopy.findIndex(
        (x) => x?._id === selectedModifier?._id
      );
      if (modifierIndex >= 0) {
        modifiersCopy[modifierIndex]["menuItemIds"] = selectedMenuItems ?? [];
        setModifierList(modifiersCopy);
      }
      const updatedModifier = {
        ...selectedModifier,
        menuItemIds: selectedMenuItems,
      };
      setSelectedModifier(updatedModifier);
    }
  };

  const onSaveModifier = (type, data) => {
    const modData = {
      ...data,
      menuItemIds: selectedModifier?.menuItemIds ?? [],
    };
    createMenuModifiers(type, modData);
  };

  const createMenuModifiers = async (type, modifier) => {
    setLoading(true);
    let modifierPayload = {
      header: modifier.header,
      required: modifier.required,
      addUpPrices: modifier?.addUpPrices ?? false,
      multiSelection: modifier?.multiSelection ?? false,
      extraAllowed: modifier?.extraAllowed ?? false,
      defaultSelection: modifier?.defaultSelection
        ? modifier?.defaultSelection
        : null,
      items: modifier.items.map((y) => y._id),
    };
    if (modifier?.isNew !== true) {
      modifierPayload = { _id: modifier._id, ...modifierPayload };
    }

    const requestBody = JSON.stringify({ modifiers: [modifierPayload] });

    const response =
      type === "edit"
        ? await Api.updateMenuModifier(
            restaurantId,
            requestBody,
            modifier?._idModifier
          )
        : await Api.createMenuModifier(restaurantId, requestBody);

    if (response.success) {
      if (type === "edit") {
        let modifiersCopy = [...modifierList];
        const modifierIndex = modifiersCopy.findIndex(
          (x) => x?._idModifier === modifier?._idModifier
        );
        if (modifierIndex >= 0) {
          modifiersCopy[modifierIndex] = modifier;
        }
        setModifierList(modifiersCopy);
        setSelectedModifier(null);
        setLoading(false);
      } else {
        const newModifierId = response?.data?._id;
        const linkData = {
          id: [newModifierId],
          menuItemIds: modifier?.menuItemIds,
        };
        modifier = {
          ...modifier,
          _idModifier: newModifierId,
        };
        linkMenuModifiers(linkData, "add", modifier);
      }
    } else {
      setLoading(false);
      setMsgAlert({
        open: true,
        message: response.msg,
        msgType: "error",
      });
    }
  };

  const linkMenuModifiers = async (data, type, modifier) => {
    setLoading(true);

    let unlinkedMenuItems = [];
    if (type === "edit") {
      unlinkedMenuItems = selectedModifier?.menuItemIds.filter(
        (x) => !selectedMenuItems.includes(x)
      );

      if (unlinkedMenuItems.length) {
        const unlinkData = {
          id: [selectedModifier?._idModifier],
          menuItemIds: unlinkedMenuItems,
        };

        const unlinkData1 = JSON.stringify(unlinkData);
        const unlinkResponse = await Api.unlinkMenuModifier(
          restaurantId,
          unlinkData1
        );
        if (!unlinkResponse.success) {
          setMsgAlert({
            open: true,
            message: unlinkResponse.msg,
            msgType: "error",
          });
          setLoading(false);
          return;
        }
      }
    }

    const linkRequestBody = JSON.stringify(data);
    const response = await Api.linkMenuModifier(restaurantId, linkRequestBody);
    if (response.success) {
      let list = [...modifierList];
      if (type === "edit") {
        const findIndex = list.findIndex(
          (x) => x?._id === selectedModifier?._id
        );
        if (findIndex >= 0) {
          list[findIndex]["menuItemIds"] = selectedMenuItems ?? [];
          setModifierList(list);
        }
        setSelectedModifier(modifier);
      } else {
        list.push(modifier);
        setModifierList(list);
        setSelectedMenuItems([]);
        setSelectedModifier(null);
      }
      let menuList = [...props.restaurantMenuList];

      unlinkedMenuItems.forEach((menuItem) => {
        const findIndex = menuList.findIndex((menu) => menu._id === menuItem);
        if (findIndex >= 0) {
          menuList[findIndex]["_idModifiers"] = menuList[findIndex][
            "_idModifiers"
          ].filter((x) => x !== data.id?.[0]);
        }
      });

      data.menuItemIds.forEach((menuItem) => {
        const findIndex = menuList.findIndex((menu) => menu._id === menuItem);
        if (findIndex >= 0) {
          const idModifiers = menuList[findIndex]["_idModifiers"];
          if (!idModifiers.includes(data.id?.[0])) {
            menuList[findIndex]["_idModifiers"].push(data.id?.[0]);
          }
        }
      });
      props.updateRestaurantMenuList(menuList);
    } else {
      setMsgAlert({
        open: true,
        message: response.msg,
        msgType: "error",
      });
    }
    setLoading(false);
  };

  const onDeleteModifier = () => {
    setAppDialogState({
      open: true,
      title: (
        <Box>
          <Typography sx={{ margin: 0 }}>
            <DeleteIcon width={"2.5rem"} height={"2.5rem"} />
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontSize: "1.5rem", fontFamily: "GilroySemiBold" }}
          >
            Delete Modifier?
          </Typography>
        </Box>
      ),
      content: (
        <Box>
          Are you sure you want to delete modifier: {selectedModifier?.header}?
        </Box>
      ),
      firstBtnText: "Cancel",
      secondBtnText: "Delete",
      onClose: handleDeleteModifierCancel,
      onConfirm: handleDeleteModifierConfirm,
    });
  };

  const handleDeleteModifierCancel = () => {
    setAppDialogState({ open: false });
  };

  const handleDeleteModifierConfirm = async () => {
    setLoading(true);
    const response = await Api.deleteMenuModifier(
      restaurantId,
      selectedModifier?._idModifier
    );
    if (response.success) {
      setModifierList(
        modifierList.filter(
          (x) => x?._idModifier !== selectedModifier?._idModifier
        )
      );
      setSelectedModifier(null);
      setAppDialogState({ open: false });
      setSelectedMenuItems([]);
    } else {
      setMsgAlert({
        open: true,
        message: response.msg,
        msgType: "error",
      });
    }
    setLoading(false);
  };

  const onCloseAlertMsg = () => {
    setMsgAlert({ open: false, message: "", msgType: "error" });
  };

  const onBackBtnClick = () => {
    navigate(`/restaurant/${restaurantId}/manage_menu`);
  };

  return (
    <Container page={"settings"} p={1.5} onSearch={() => null}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "70vh",
          }}
        >
          <Loader />
        </Box>
      ) : (
        <Grid container item xs={12} justifyContent={"space-between"}>
          <Grid item xs={12} mb={2}>
            <RestaurantHeader
              title={"Manage Modifiers"}
              onBackBtnClick={() => navigate(-1)}
            />
          </Grid>
          <Grid item xs={12} md={5.9}>
            <AddModifiers
              page={"modifier"}
              restaurantId={restaurantId}
              initialShowHeaderOnly={true}
              initialExpandModifier={true}
              categoryList={categoryList}
              menuList={props.restaurantMenuList}
              modifiers={modifierList}
              menuItems={selectedModifier?.menuItemIds ?? []}
              modifierAddOption={true}
              editOrEditItem={"edit"}
              selectedModifier={selectedModifier}
              currency={props.restaurantDetail?.currecnyIcon ?? null}
              setModifierList={() => null}
              modifierEditable={true}
              showBackBtn={true}
              showDeleteAllBtn={false}
              onBackBtnClick={onBackBtnClick}
              onModifierClick={onModifierClick}
              onSaveModifier={onSaveModifier}
              onDeleteModifier={onDeleteModifier}
              modifierListViewStyle={{
                maxHeight: "calc(100vh - 300px)",
                overflow: "auto",
              }}
            />
          </Grid>
          {props.restaurantMenuList.length && selectedModifier ? (
            <Grid item xs={12} md={5.9}>
              <Box className={`${styles["menu-main-view"]}`}>
                <Box className={`${styles["header-view"]}`}>
                  <Typography className={`${styles["header-text"]}`}>
                    Menu - {selectedModifier?.header ?? "Add"}
                  </Typography>
                </Box>
                {/* {MenuItemList} */}
                <ModifierMenuItems
                  menuList={props.restaurantMenuList}
                  menuCategoryList={menuCategoryList}
                  selectedModifier={selectedModifier}
                  selectedItems={selectedMenuItems}
                  onSelectMenu={onSelectModifierMenu}
                />
                <Box className={`${styles["footer-view"]}`}>
                  {JSON.stringify(selectedMenuItems) ===
                  JSON.stringify(selectedModifier?.menuItemIds ?? []) ? null : (
                    <Button
                      onClick={onSaveModifierMenu}
                      type="button"
                      className={`${styles["save-btn"]}`}
                    >
                      Save
                    </Button>
                  )}
                </Box>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      )}
      <AlertMsg msgAlert={msgAlert} onCloseAlertMsg={onCloseAlertMsg} />
      <AppDialog
        open={appDialogState.open}
        onClose={appDialogState.onClose}
        content={appDialogState.content}
        title={appDialogState.title}
        firstBtnContent={appDialogState.firstBtnText}
        secondBtnContent={
          loading ? "Please Wait..." : appDialogState.secondBtnText
        }
        firstBtnClickHandler={appDialogState.onClose}
        secondBtnClickHandler={appDialogState.onConfirm}
        options={{ loading }}
      />
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateRestaurantMenuList: (data) =>
      dispatch(updateRestaurantMenuList(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    themeMode: state.userData.themeMode,
    restaurantId: state.userData.restaurantId,
    restaurantDetail: state.userData.restaurantDetail,
    restaurantMenuList: state.userData.restaurantMenuList,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modifiers);
